import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';


const mapStateToProps = (state) => ({
  userRoles: state.getIn(['session', 'roles'], '').split(','),
}
);

/**
 * Проверяет входит ли роль roles в userRoles
 * @param userRoles
 * @param roles
 * @returns {boolean}
 */
function isHaveAnyRole(userRoles, roles) {
  return (_.intersection(userRoles, roles).length > 0);
}


/**
 * Фильтр по ролям пользователей.
 * Если текущий пользователь имеет хотя бы одну роль, то отображаем содержимое тегов.
 * Иначе скрываем методом method. Дочерние компоненты должны реализовывать метод сокрытия,
 * читая из переменной context свойства disabled или readonly,
 * например, добавляя в нужные компоненты свойство disabled={this.context.disabled}
 */
class RolesFilterClass extends React.Component {
  getChildContext() {
    // if user have no role, then pass to child's components context different properties,
    // depend on hide method. see https://facebook.github.io/react/docs/context.html for moe info
    if (!isHaveAnyRole(this.props.userRoles, this.props.roles)) {
      if (this.props.method == 'disable') {
        return { disabled: true };
      }
      if (this.props.method == 'readonly') {
        return { readonly: true };
      }
    }
    return null;
  }

  render() {
    // if component hide method is 'disable' or 'readonly' then whe should display all children
    // and pass child context to it
    if (this.props.method == 'disable'
      || this.props.method == 'readonly'
      || isHaveAnyRole(this.props.userRoles, this.props.roles)) {
      return this.props.children;
    }
    return null;
  }
}

RolesFilterClass.propTypes = {
  // роли которые нужно проверить
  roles: React.PropTypes.array.isRequired,
  // текущие роли пользователя
  userRoles: React.PropTypes.array.isRequired,
  children: React.PropTypes.node,
  method: React.PropTypes.oneOf(['hide', 'disable', 'readonly']),
};

// make information available to its children
RolesFilterClass.childContextTypes = {
  disabled: React.PropTypes.bool,
  readonly: React.PropTypes.bool,
};

/**
 * Если текущий пользователь имеет хотя бы одну роль, то отображаем содержимое тегов.
 * Иначе скрываем методом method. Дочерние компоненты должны реализовывать метод сокрытия,
 * читая из переменной context свойства disabled или readonly,
 * например, добавляя в нужные компоненты свойство disabled={this.context.disabled}
 */
class HaveRolesClass extends RolesFilterClass {

}

/**
 * Если текущий пользователь не имеет ни одну из ролей, то отображаем содержимое тегов.
 * Иначе скрываем методом method. Дочерние компоненты должны реализовывать метод сокрытия,
 * читая из переменной context свойства disabled или readonly,
 * например, добавляя в нужные компоненты свойство disabled={this.context.disabled}
 */
class HaveNotRolesClass extends RolesFilterClass {
  getChildContext() {
    // if user have role, then pass to child's components context different properties,
    // depend on hide method. see https://facebook.github.io/react/docs/context.html for moe info
    if (isHaveAnyRole(this.props.userRoles, this.props.roles)) {
      if (this.props.method == 'disable') {
        return { disabled: true };
      }
      if (this.props.method == 'readonly') {
        return { readonly: true };
      }
    }
    return null;
  }
}

/* eslint-disable no-unused-vars */
export const RolesFilter = connect(mapStateToProps)(RolesFilterClass);
export const HaveRoles = connect(mapStateToProps)(HaveRolesClass);
export const HaveNotRoles = connect(mapStateToProps)(HaveNotRolesClass);
